import '../styles/Charts.css';

function KpiCards({ kpis = [] }) {
  return (
    <div className="kpi-cards-row">
      {kpis.map((k, i) => {
        const trend = k.change_pct;
        const hasTrend = trend != null && trend !== undefined;
        const cls = hasTrend ? (trend > 0 ? 'trend-up' : trend < 0 ? 'trend-down' : 'trend-flat') : '';
        const icon = hasTrend ? (trend > 0 ? '\u25B2' : trend < 0 ? '\u25BC' : '\u2014') : '';
        return (
          <div key={i} className="kpi-card">
            <div className="kpi-card-label">{k.label}</div>
            <div className="kpi-card-value">{k.prefix || ''}{k.value}{k.suffix || ''}</div>
            {hasTrend && (
              <div className={`kpi-card-trend ${cls}`}>
                {icon} {trend > 0 ? '+' : ''}{trend}%
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default KpiCards;
